export enum TransactionType {
  BankDebit = 'bank_debit',
  Credit = 'credit',
  Debit = 'debit',
  Transfer = 'transfer',
}
